import { useEffect, useState } from "react";
import { useQuestionizerStore } from "../types/state.ts";

export default function Toggle (props: {id: string, value: boolean, info_title?: string, info_text?: string, icon?:string, icon_active?:string, onBlur?: ()=> void, onChange: (value: boolean) => void,  label: string, count?: number}){
  const useLabels = useQuestionizerStore((state) => state.config?.use_labels);
  const svg_mode = useQuestionizerStore((state) => state.config?.svg_mode);
  const show_count = (props.count !== undefined && props.count > 0);
  const icon_url = (props.value && props.icon_active) ? `url(${props.icon_active})` : `url(${props.icon})`;
  
  const [svg_icon, set_svg_icon] = useState<string>('');

  // const use_font_awesome = props.fontawesome_icon !== undefined && props.fontawesome_icon !== "";
  // console.log("fontasas", props.fontawesome_icon);
  
  const icon_type : "svg" | "png" | "fontawesome" = (props.icon?.endsWith(".svg") && svg_mode == "inline_svg") ? "svg" : ((props.icon?.endsWith(".png") || (props.icon?.endsWith(".svg") && svg_mode == "background")) ? "png" : "fontawesome")

  useEffect(()=>{
    async function fetch_icon(){
      const response = await fetch(props.icon);
      const svg_text = await response.text();
      set_svg_icon(svg_text.replace('<?xml version="1.0" encoding="UTF-8"?>', ''));
    }
    if(icon_type == "svg"){
      fetch_icon();
    }
  },[]);

  return <div role="checkbox" 
          aria-checked={props.value || false} 
          aria-label={props.label}
          tabIndex={0}
          className={"toggle input-"+props.id} 
          onClick={()=>{props.onChange(!props.value)}}
          onBlur={props.onBlur}
          onKeyUp={(event)=>{
            if ((event.key != "Enter") && (event.key != " ")){ return; }
			      event.stopPropagation();
            props.onChange(!props.value);
          }}
          >
          {show_count && 
            <div className="toggle-bubble">
              {props.count}
            </div>
          }
		 	  
          {icon_type == "fontawesome" && 
			<div aria-hidden className={"toggle__svg_img "  + (props.value ? "toggle__img--active " : "")}>
				<i className={'fa '+ getLastPart(props.icon!)}></i>
			</div>
          }
          {icon_type == "svg" && svg_icon && <div aria-hidden className={"toggle__svg_img "  + (props.value ? "toggle__img--active " : "")} dangerouslySetInnerHTML={{__html:svg_icon}} />}
          {icon_type == "png" && !svg_icon && <div aria-hidden className={"toggle__img " + (props.value ? "toggle__img--active " : "") + (show_count ? "toggle__img--has-count " : "")} style={{backgroundImage: icon_url}}></div>}
          
          {useLabels && <label aria-hidden className='toggle__label'>{props.label}</label>}
          <div className="toggle__infos">
            {props.info_title && <p className="font-bold mb-3">{props.info_title}</p>}
            {props.info_text && <p className="">{props.info_text}</p>}
          </div>
          
        </div>
}

function getLastPart(str: string): string {
  if (!str) return "";

  const safeDecode = (s: string) => {
    try { return decodeURIComponent(s); } catch { return s; }
  };

  try {
    // Prüfen, ob es eine gültige URL ist
    const url = new URL(str);
    const lastPath = url.pathname.split("/").filter(Boolean).pop() || "";
    return safeDecode(lastPath).trim();
  } catch {
    // Kein URL → komplette (dekodierte) Class-Liste zurückgeben
    return safeDecode(str).trim();
  }
}
